
import { all, call, select, put, takeLatest } from "redux-saga/effects";
import * as jsonpatch from "fast-json-patch";
import { UPDATE_ITEM,
  updateItemFailure,
  updateItemRequested,
  updateItemSuccess } from "../actions/item-action-types";
import { fetchRoom } from "../actions/catelogue-types";
import httpClient from "./http-client";

export function* updateItemHandler({ payload }) {
  yield put(updateItemRequested());
  const roomData = yield select((state) => state?.catalogue?.rooms);
  const room = roomData.find((x) => x.identifier === payload.identifier);

  const update = {
    ...room, ...payload,
  };
  const result = jsonpatch.compare(room, update);

  if (result.length) {
    const request = {
      data: { payload: result },
      method: "PATCH",
      url: `/api/v1/catalogue/${room.identifier}`,
    };

    const {
      data, error,
    } = yield call(httpClient, request, true);

    if (error) {
      yield put(updateItemFailure(error));
    } else {
      yield put(fetchRoom(payload.taskId));
      yield put(updateItemSuccess(data));
    }
  }
}

function* Items() {
  yield all([
    takeLatest(UPDATE_ITEM, updateItemHandler),
  ]);
}

export default Items;
